import React, { useState, useEffect, useCallback } from "react";
import {
    View,
    TouchableOpacity,
    Text,
    Dimensions,
} from "react-native";
import { Feather } from "@expo/vector-icons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { LinearGradient } from "expo-linear-gradient";
import NumberInput from "../../components/NumberInput";
import ScreenLoader from "../../components/ScreenLoader";
import { formatGPXBalance } from "../../utils/formatNumber";
import api from "../../services/api";

import { LineChart } from "react-native-chart-kit";

import HeaderDefault from "../../components/HeaderDefault";
import HeaderInfoToken from "../../components/HeaderInfoToken";

import styles from "./styles";
import LineChartByActive from "../../components/LineChartByActive";
import HeaderInfoCoin from "../../components/HeaderInfoCoin";

const DetailsCoin = ({ navigation }) => {
    const [qtd, setQtd] = useState(0);
    const [dataToken, setDataToken] = useState([]);
    const [active, setActive] = useState();
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [infosToken, setInfosToken] = useState([]);
    const [dataGraphic, setDataGraphic] = useState([0, 0, 0, 0, 0, 0]);
    const [dateGraphic, setDateGraphic] = useState([
        "00/00",
        "00/00",
        "00/00",
        "00/00",
        "00/00",
        "00/00",
        "00/00",
    ]);
    const screenWidth = Dimensions.get("window").width;

    useEffect(() => {
        getDataToken();
        getData();
    }, []);

    const getDataToken = async () => {
        const authToken = await AsyncStorage.getItem("JWT_TOKEN");
        const idToken = await AsyncStorage.getItem("id_token");
        setLoading1(true)
        api
            .get(`/actives/${idToken}`, {
                headers: { Authorization: `Basic ${authToken}` },
            })
            .then((res) => {
                console.log('datatoken');
                console.log(res.data);
                setDataToken(res.data);
                if (res.data.actives.length > 0) {
                    setActive(res.data.actives[0]);
                }
                setLoading1(false)
            })
            .catch((error) => {
                setLoading1(false)
                console.log(error);
            });
    };

    const getData = async () => {
        const authToken = await AsyncStorage.getItem("JWT_TOKEN");
        const idToken = await AsyncStorage.getItem("id_token");
        setLoading2(true)
        api
            .get(`/marketplace-moviments/${idToken}`, {
                headers: { Authorization: `Basic ${authToken}` },
            })
            .then((res) => {
                setInfosToken(res.data);
                //console.log(res.data.lastPrice.purchase_quantity_brl);
                setDataGraphic(res.data.graphic);

                var dates = [];

                var i = 8;
                while (true) {
                    i--;
                    const date = new Date();
                    date.setDate(date.getDate() - i);
                    var dayNow = date.getDate();
                    var month = date.getMonth();

                    var monthFormat = month < 10 ? `0${month}` : month;

                    var daysFormat =
                        dayNow < 10
                            ? `0${dayNow}/${monthFormat}`
                            : `${dayNow}/${monthFormat}`;
                    dates.push(daysFormat);
                    if (i === 1) {
                        break;
                    }
                }
                setLoading2(false)
                setDateGraphic(dates);
            })
            .catch((error) => {
                setLoading2(false)
                console.log(error);
            });
    };

    const handleBuyToken = async () => {
        navigation.navigate("ConfirmPurchaseOrSell", { qtd: qtd, token: active.id, viewType: 'buy', market: false });
    };

    const getTokenValue = () => {
        return (dataToken?.actives?.length > 0 ? dataToken?.actives[0].single_value : 0)
    }

    const getMoreInfo = async () => {
        await AsyncStorage.setItem('id_coin', active.id + '');
        navigation.navigate("MoreInfosCoin")
    }

    return (
        <>
            <ScreenLoader loading={loading1 || loading2} />
            <HeaderDefault title={"MARKETPLACE"} />

            <View style={styles.container}>
                {/* <HeaderInfoToken dataToken={dataToken} /> */}

                <HeaderInfoCoin dataCoin={dataToken} />
                <View style={styles.hrLine}></View>
                <TouchableOpacity
                    style={styles.contentMore}
                    onPress={() => getMoreInfo()}
                >
                    <Text style={styles.textMore}>Mais informações</Text>
                    <Feather name="arrow-right" size={24} color="#1F26BF" />
                </TouchableOpacity>

                {/* <View>
          <LineChart
            data={{
              labels: dateGraphic,
              datasets: [
                {
                  data: dataGraphic,
                },
              ],
            }}
            width={screenWidth} // from react-native
            height={220}
            withHorizontalLabels={false}
            chartConfig={{
              backgroundGradientFromOpacity: 0,
              backgroundGradientToOpacity: 0,
              decimalPlaces: 2, // optional, defaults to 2dp
              color: (opacity = 0.1) => `rgba(244, 156, 22, ${opacity})`,
              labelColor: (opacity = 1) => `rgba(0, 0, 0, ${opacity})`,
              style: {
                borderRadius: 16,
              },
              propsForDots: {
                r: "7",
                strokeWidth: "2",
                stroke: "#ffa726",
              },
            }}
            bezier
            style={{
              marginVertical: 8,
              borderRadius: 16,
              marginLeft: -34,
            }}
          />

          
          </View> */}

                <View style={{ marginTop: 15, marginBottom: 15 }}>
                    {/* <LineChartByActive price={active?.single_value || 0.00} /> */}
                </View>

                {/* <View style={styles.contentTitleBottomLine}>
                    {/* <Text style={styles.nameTitleBottomLine}>VARIAÇÃO</Text>}
                    <Text style={styles.nameTitleBottomLine}>ÚLTIMA</Text>
                    <Text style={styles.nameTitleBottomLine}>MENOR</Text>
                    <Text style={styles.nameTitleBottomLine}>MAIOR</Text>
                    <Text style={styles.nameTitleBottomLine}>VOLUME EM 24H</Text>
                </View>

                <View style={styles.contentInfoBottomLine}>
                    {/* <Text style={styles.InfoBottomLineVariation}>+2,37%</Text>}

                    <Text style={styles.InfoBottomLine}>R$ {infosToken.maxPrice}</Text>
                    <Text style={styles.InfoBottomLine}>R$ {infosToken.minPrice}</Text>
                    <Text style={styles.InfoBottomLine}>R$ {infosToken.maxPrice}</Text>
                    <Text style={styles.InfoBottomLine}>{parseFloat(infosToken.lastHours + '')} {dataToken?.actives?.length > 0 && dataToken?.actives[0].name_token}</Text>
                </View> */}

                <View style={styles.hrLine}></View>
            </View>
            <View style={styles.contentPurchase}>
                <Text style={styles.titlePurchase}>
                    Quanto deseja?
                </Text>
                <View style={styles.contentPurchaseAmount}>
                    <NumberInput value={qtd} onChange={value => setQtd(value)}
                    />
                </View>
                <View style={{ alignItems: 'center' }}>
                    <Text style={{ color: '#656565', paddingTop: 5 }}>{qtd > 0 && getTokenValue() > 0 && (formatGPXBalance(qtd * getTokenValue()) + ' GPX/BRL')}</Text>
                </View>
            </View>
            <View style={styles.contentBtn}>
                <TouchableOpacity
                    disabled={qtd <= 0 ? true : false}
                    onPress={() => handleBuyToken(dataToken)}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#16195B", "#1FBFB5"]}
                        style={styles.btn}
                    >
                        <Text style={styles.textBtn}>COMPRAR</Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>
        </>
    );
};

export default DetailsCoin;
